import React, { createContext, useContext } from "react";

import type { AiFieldLookupMap } from "../components/CellRenderers/AiStatusCellRenderer";

const AiFieldLookupContext = createContext<AiFieldLookupMap>({});

export const AiFieldLookupProvider = ({
  fieldLookup,
  children,
}: {
  fieldLookup: AiFieldLookupMap;
  children: React.ReactNode;
}): React.JSX.Element => (
  <AiFieldLookupContext.Provider value={fieldLookup}>
    {children}
  </AiFieldLookupContext.Provider>
);

export const useAiFieldLookup = (): AiFieldLookupMap =>
  useContext(AiFieldLookupContext);
